import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetOfferById } from '@occc-app/dataAccessLayer/offer/queries';
import { useChainId } from '@occc-app/Chain/hooks';

import { OfferDetailsPage } from './OfferDetailsPage';

const OfferDetailsPageContainer: React.FC = () => {
  const chainId = useChainId();
  const { id: offerId = '' } = useParams<{ id: string }>();
  const { loading, error, data } = useGetOfferById(offerId, chainId);

  return <OfferDetailsPage loading={loading} error={error} offer={data} />;
};

export default OfferDetailsPageContainer;
